<template>
  <div class="statistical-report-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime">
      </el-date-picker>
      <el-button type="primary" size="small" @click="getUserTody()">搜索</el-button>
      <span v-if="grossBool" style="margin-left: 50px; font-size:18px;">查询视频金币总收入: {{ gross }}</span>
    </div>
    <!--表格数据-->
    <el-table
      max-height="650"
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading">
      <el-table-column prop="id" label="视频Id" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="视频标题" align="center" width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="视频上传日期" align="center" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.created_at | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="publisher_id" label="视频发布用户Id" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.publisher_id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="publisher_name" label="视频发布用户姓名" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.publisher_name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="count" label="视频购买总次数" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.count }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="total" label="视频总金币数" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.total }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coins" label="视频定价" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.coins }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { changeTime } from "@/utils/global";
import API from "@/api";
export default {
  data() {
    return {
      // 时间数据绑定字段
      time: "",
      tableData: [],
      gross: 0,//时间段内所有视频金币总收入
      grossBool: false,
      // 表格数据加载动画
      loading: false,
      // 用户今日统计列表请求参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        startTime: null,
        endTime: null,
      },
    };
  },
  created() {
    this.getUserTody();
  },
  methods: {
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || null;
        this.params.endTime = changeTime(time[1]) || null;
      } else {
        this.params.startTime = null;
        this.params.endTime = null;
      }
      this.getUserTody();
    },
    // 请求用户今日统计列表数据
    getUserTody() {
      this.loading = true;
      API.getVideoPayGoldStat({ ...this.params })
        .then((res) => {
          this.loading = false;
          this.grossBool = false;
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.gross = res.data.gross;
            if (res.data.list.length > 0) {
              this.grossBool = true;
            }
          } else {
            this.tableData = [];
            this.gross = 0;
            this.grossBool = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
